import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { mainAxios } from "../../app/api";
import service from "../../config.json";
import { errorToast, successToast } from "../../helpers/toaster";
const { addInsurance, getInsurance, updateInsurance } = service;
const { Authorization } = JSON.parse(sessionStorage.getItem("userData")) || {};

const initialState = {
  insuranceStatus: "",
  passengersCount: 1,
  insuranceList: [],
  loading: false,
  insuranceUpdateStatus: false,
};

export const addInsuranceAsync = createAsyncThunk(
  "insurance/addInsuranceAsync",
  async (state) => {
    const {
      Title,
      FirstName,
      LastName,
      Country,
      Email,
      StartDate,
      EndDate,
      MobileNo,
      CountryCode,
      TravellingCountry,
    } = state.state;
    const { passengers, Authorization } = state;
    let arr = [];

    passengers.map((ele) => {
      arr.push({ age: ele.Age, pre_disease: ele.Disease });
    });
    try {
      const res = await mainAxios.post(
        addInsurance,
        {
          nameTitle: Title,
          firstName: FirstName,
          lastName: LastName,
          user_country: Country,
          email: Email,
          travel_country: TravellingCountry,
          start_date: StartDate,
          end_date: EndDate,
          totalPerson: state.passengers.length,
          country_code: CountryCode,
          mobile: MobileNo,
          passangers: arr,
        },
        {
          headers: {
            Authorization,
          },
        }
      ); //the api name later
      return res.data;
    } catch (err) {
      return err.response;
    }
  }
);

// updateInsuranceAsync
export const updateInsuranceAsync = createAsyncThunk(
  "insurance/updateInsuranceAsync",
  async (state) => {
    const {
      Title,
      FirstName,
      LastName,
      Country,
      Email,
      StartDate,
      EndDate,
      MobileNo,
      CountryCode,
      TravellingCountry,
    } = state.state;
    const { passengers, Authorization } = state;
    let arr = [];

    passengers.map((ele) => {
      arr.push({ age: ele.Age, pre_disease: ele.Disease });
    });
    try {
      const res = await mainAxios.post(
        updateInsurance,
        {
          insurance_id: state.editId,
          nameTitle: Title,
          firstName: FirstName,
          lastName: LastName,
          user_country: Country,
          email: Email,
          travel_country: TravellingCountry,
          start_date: StartDate,
          end_date: EndDate,
          totalPerson: state.passengers.length,
          country_code: CountryCode,
          mobile: MobileNo,
          passangers: arr,
        },
        {
          headers: {
            Authorization,
          },
        }
      ); //the api name later
      return res.data;
    } catch (err) {
      return err.response;
    }
  }
);

// fetchMyInsurance;
export const fetchMyInsurance = createAsyncThunk(
  "insurance/fetchMyInsurance",
  async (Authorization) => {
    try {
      const res = await mainAxios.get(getInsurance, {
        headers: {
          Authorization,
        },
      }); //the api name later
      return res.data;
    } catch (err) {
      return err.response;
    }
  }
);

export const insuranceSlice = createSlice({
  name: "insurance",
  initialState,
  reducers: {
    increment: (state) => {
      state.passengersCount += 1;
    },
    decrement: (state) => {
      state.passengersCount -= 1;
    },
    resetInsuranceStaus: (state) => {
      state.insuranceStatus = "";
    },
    setPassengerCount: (state, { payload }) => {
      state.passengersCount = parseInt(payload);
    },
  },
  extraReducers: {
    [addInsuranceAsync.pending]: (state) => {
      return { ...state, loading: true };
    },
    [addInsuranceAsync.fulfilled]: (state, { payload }) => {
      if (payload?.success) {
        return { ...state, insuranceStatus: payload.success, loading: false };
      } else {
        errorToast(payload?.message);
        return { ...state, loading: false };
      }
    },
    [fetchMyInsurance.pending]: (state) => {
      return { ...state, loading: true };
    },
    [fetchMyInsurance.fulfilled]: (state, { payload }) => {
      if (payload?.success) {
        return { ...state, insuranceList: payload.data, loading: false };
      } else {
        errorToast(payload?.message);
        return { ...state, loading: false };
      }
    },
    [updateInsuranceAsync.pending]: (state) => {
      return { ...state, loading: true };
    },
    [updateInsuranceAsync.fulfilled]: (state, { payload }) => {
      if (payload?.success) {
        successToast("Insurance Updated Successfully!");
        return { ...state, loading: false, insuranceUpdateStatus: true };
      } else {
        errorToast(payload?.message);
        return { ...state, loading: false };
      }
    },
  },
});

export const getPassengersCount = (state) => {
  return state.insurance.passengersCount;
};

export const getInsuranceList = (state) => {
  return state.insurance.insuranceList;
};

// Action creators are generated for each case reducer function
export const { increment, decrement, resetInsuranceStaus, setPassengerCount } =
  insuranceSlice.actions;

export default insuranceSlice.reducer;
